export default __webpack_public_path__ + "static/media/img_chart_grade_A.d25e1c3a7579a06a451f00407f89ebc8.svg";